module.exports = __webpack_public_path__ + "resources/img/configure_id.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/configure_id.png
// module id = 1439
// module chunks = 0